import BaseServiceCrud from "./BaseServiceCrud";
import moment from "moment";
import Constants from "../utils/constants";
const path = 'public-holidays';

export default class PublicHolidaysService extends BaseServiceCrud  {
    // Initializing important variables
    constructor() {
        super();
        this.path = path;
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            name: criteria.name,
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    getAll() {
        return this.fetch(`${this.domain}/${this.path}/list`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getEvents(date){
        const currentDate = moment(date).format(Constants.DATE_GET_REQUEST_FORMAT_TIME);
        const year = ''+ date;
            return this.fetch(`${this.domain}/${this.path}/own/calendar/${year}`, {
            method: 'GET',
        })
        .then((res) => {
            return Promise.resolve(res);
        })
        .catch((err) => {
            throw err;
        });
    }

    getYearOptions(){
            return this.fetch(`${this.domain}/${this.path}/calendar/year-opt`, {
            method: 'GET',
        })
        .then((res) => {
            return Promise.resolve(res);
        })
        .catch((err) => {
            throw err;
        });
    }
}
